import _ from 'lodash';
import moment from 'moment';
import { MUTATION_TYPES } from './types';
import { initialState } from './state'; //Import initial state object for reset when was destroy
import visitTypeCategories from '@/utils/constants/visitTypeCategories.js';

export default {
  [MUTATION_TYPES.RESET](state) {
    Object.assign(state, initialState());
  },
  [MUTATION_TYPES.SET_ACADEMIC_YEARS](state, academicYears) {
    state.catalog.academicYears = academicYears;
  },
  [MUTATION_TYPES.SET_MONTHS](state, months) {
    state.catalog.months = months;
  },
  [MUTATION_TYPES.SET_MONTHS_ORIGINAL](state, months) {
    state.catalog.monthsOriginal = months;
  },
  [MUTATION_TYPES.SET_SERVICES](state, services) {
    state.catalog.services = services;
  },
  [MUTATION_TYPES.SET_CENTERS](state, centers) {
    state.catalog.centers = centers;
  },
  [MUTATION_TYPES.SET_PROVIDERS](state, payload) {
    state.catalog.providers = payload;
  },
  [MUTATION_TYPES.SET_LOCATIONSTYPE](state, locationsType) {
    state.catalog.locationsType = locationsType;
  },
  [MUTATION_TYPES.SET_LOCATION](state, locations) {
    state.catalog.locations = locations;
  },
  [MUTATION_TYPES.SET_SUPERVISED_SPECIALISTS](state, supervisedSpecialists) {
    state.catalog.supervisedSpecialists = supervisedSpecialists;
  },
  [MUTATION_TYPES.SET_ADDITIONAL_INFORMATION](state, item) {
    state.filter.results = state.filter.results.map((s) => {
      if (s.id === item.id) {
        s.visits = item.visits;

        s.visitsRegular = item.visits.filter((x) =>
          x.visitTypeCategoryIds?.includes(visitTypeCategories.Asistencia)
        );
        s.visitsAbsence = item.visits.filter((x) =>
          x.visitTypeCategoryIds?.includes(visitTypeCategories.Ausencia)
        );
        s.visitsCompensatory = item.visits.filter((x) =>
          x.visitTypeCategoryIds?.includes(
            visitTypeCategories.HorasCompensatorias
          )
        );
        s.isOpen = !s.isOpen;
      } else {
        s.isOpen = false;
      }
      return s;
    });
  },

  [MUTATION_TYPES.SET_RESULTS](state, results) {
    state.filter.results = results.data.map((s) => {
      s.isOpen = false;
      return s;
    });
    state.paging = {
      count: results.count,
      currentPage: results.currentPage,
      pageCount: results.pageCount,
      totalItemCount: results.totalItemCount,
    };
  },
  [MUTATION_TYPES.SET_FILTERED_PERIOD](state, payload) {
    state.filteredPeriod = payload;
  },
  [MUTATION_TYPES.SET_VISIT_TYPES](state, payload) {
    state.catalog.visitTypes = payload;
  },
  [MUTATION_TYPES.SET_DOCUMENT_TYPES](state, payload) {
    state.catalog.documentTypes = payload;
  },
  [MUTATION_TYPES.SET_PRACTITIONER](state, payload) {
    state.catalog.practitioners = payload;
  },
  [MUTATION_TYPES.SET_VISIT_ABSENCE_REGISTRATION](state, payload) {
    state.catalog.visitAbsenceRegistration = payload;
  },
  [MUTATION_TYPES.SET_VISITS](state, payload) {
    state.visits = payload;
  },
  [MUTATION_TYPES.SET_VISIT_ENTRY](state, { entryIndex, prop }) {
    state.visits = {
      ...state.visits,
      data: state.visits.data.map((item, index) => {
        if (entryIndex === index) {
          item = {
            ...item,
            ...prop,
          };
        }
        return item;
      }),
    };
  },
  [MUTATION_TYPES.SET_VISIT_REGISTERED](state, { itemIndex, id }) {
    state.visits.data.map((item, index) => {
      if (index === itemIndex) {
        item.id = id;
        item.isOpen = false;
        item.saved = true;
      }
    });
    state.visits = {
      ...state.visits,
      data: [...state.visits.data, {}],
    };
  },
  [MUTATION_TYPES.SET_DELETE_VISIT](state, index) {
    state.visits.data.splice(index, 1);
  },
  [MUTATION_TYPES.SET_VISIT_VALID_REPLACEMENT](state, payload) {
    state.catalog.replacements = payload;
  },
  [MUTATION_TYPES.SET_VISIT_VALID_REPOSITION](state, payload) {
    state.catalog.repositions = payload;
  },
  [MUTATION_TYPES.SET_FINALIZED_PERIOD](state, payload) {
    state.isPeriodFinalized = payload;
    if (
      state.visits.data.length > 0 &&
      state.visits.data[state.visits.data.length - 1].id == null
    ) {
      state.visits.data.pop();
    }

    if (!state.isPeriodFinalized) {
      state.visits = {
        ...state.visits,
        data: [...state.visits.data, {}],
      };
    }
  },
  [MUTATION_TYPES.SET_VISIT_VALIDATION_INFO](state, payload) {
    state.visits = {
      ...state.visits,
      data: state.visits.data.map((x) => {
        x.isOpen = false;
        return x;
      }),
    };
    if (payload.errorCount > 0) {
      const grouped = _.groupBy(payload.errorMessage, 'visitId');
      if (grouped) {
        state.visits = {
          ...state.visits,
          data: state.visits.data.map((x) => {
            const key = x.id;
            if (grouped[key]) {
              x.errors = grouped[key].map(({ errorMessage }) => errorMessage);
            } else {
              x.errors = null;
            }
            return x;
          }),
        };
      }
    }
  },
  [MUTATION_TYPES.SET_SPECIALIST_REPLACEMENT](state, payload) {
    state.catalog.specialistsReplacement = payload;
  },
  [MUTATION_TYPES.SET_VISIT_LIST](state, payload) {
    state.visits.data = payload.map((x) => {
      const startHour = moment(x.visitTimeStart, 'HH:mm:ss').hours();
      const startMinute = moment(x.visitTimeStart, 'HH:mm:ss').minutes();

      const hourStartFormat = moment().set({
        hour: startHour,
        minute: startMinute,
      });

      const endHour = moment(x.visitTimeEnd, 'HH:mm:ss').hours();
      const endMinute = moment(x.visitTimeEnd, 'HH:mm:ss').minutes();

      const hourEndFormat = moment().set({
        hour: endHour,
        minute: endMinute,
      });

      x.hourStartHour = hourStartFormat.format('hh');
      x.hourStartTime = hourStartFormat.format('A').toLowerCase();
      x.hourEnd = hourEndFormat.format('hh:mm A').toLowerCase();
      x.saved = true;

      //document
      x.documentType = x.documentType?.id ? x.documentType : null;

      //specialist
      x.selectedSpecialistOption = x.selectedSpecialist?.id ? true : false;
      x.selectedSpecialist = x.selectedSpecialist?.id
        ? x.selectedSpecialist
        : null;

      //place type
      x.selectedPlaceOption = x.selectedPlaceType?.id ? true : false;
      x.selectedPlaceType = x.selectedPlaceType?.id
        ? x.selectedPlaceType
        : null;
      x.selectedRegion = x.selectedRegion?.id ? x.selectedRegion : null;
      x.selectedDistrict = x.selectedDistrict?.id ? x.selectedDistrict : null;
      x.selectedMunicipality = x.selectedMunicipality?.id
        ? x.selectedMunicipality
        : null;
      x.selectedCenter = x.selectedCenter?.id ? x.selectedCenter : null;
      x.selectedSchool = x.selectedSchool?.id ? x.selectedSchool : null;
      x.selectedLocationService = x.selectedLocationService?.id
        ? x.selectedLocationService
        : null;

      return x;
    });

    if (
      state.visits.data.length > 0 &&
      state.visits.data[state.visits.data.length - 1].id == null
    ) {
      state.visits.data.pop();
    }

    if (!state.isPeriodFinalized) {
      state.visits = {
        ...state.visits,
        data: [...state.visits.data, {}],
      };
    }
  },
  [MUTATION_TYPES.SET_VISIT_LOCATION](state, payload) {
    state.catalog.visitLocations = payload;
  },
  [MUTATION_TYPES.SET_VISIT_REGION](state, payload) {
    state.catalog.visitRegions = payload;
  },
  [MUTATION_TYPES.SET_VISIT_DISTRICT](state, payload) {
    state.catalog.visitDistricts = payload;
  },
  [MUTATION_TYPES.SET_VISIT_SCHOOL](state, payload) {
    state.catalog.visitSchools = payload;
  },
  [MUTATION_TYPES.SET_VISIT_MUNICIPALITIES](state, payload) {
    state.catalog.visitMunicipalities = payload;
  },
  [MUTATION_TYPES.SET_VISIT_LOCATION_SERVICE](state, payload) {
    state.catalog.visitLocationServices = payload;
  },
  [MUTATION_TYPES.SET_VISIT_CENTER](state, payload) {
    state.catalog.visitCenters = payload;
  },
  [MUTATION_TYPES.SET_CLEAR_CATALOG](state, payload) {
    state.catalog = {
      ...state.catalog,
      ...payload,
    };
  },
  [MUTATION_TYPES.SET_SELECTED_PERIOD](state, payload) {
    state.selectedPeriod = payload;
  },
  [MUTATION_TYPES.SET_SPECIALIST](state, specialists) {
    state.catalog.specialists = specialists;
  },
  [MUTATION_TYPES.SET_FILTER_PROP](state, { prop, value }) {
    state.filter[prop] = value;
  },

  [MUTATION_TYPES.SET_PREVIOUS_ACADEMIC_YEARS](state, value) {
    state.catalog.previousAcademicYears = value;
  },
  [MUTATION_TYPES.SET_VISIT_FILTER](state, payload) {
    state.selectedVisitFilter = payload;
  },
};
